import { render, staticRenderFns } from "./LandingPageTemplate1.vue?vue&type=template&id=36c033ad&"
import script from "./LandingPageTemplate1.vue?vue&type=script&lang=js&"
export * from "./LandingPageTemplate1.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageTemplate1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports